class MarkupModal extends HTMLElement {
  constructor() {
    super();

    this.innerWrapper = this.querySelector("[data-inner-wrapper]");
    this.inner = this.querySelector("[data-inner]");
    this.content = this.querySelector("[data-content]");

    this.handleOpen = (e) => {
      if (e.detail.target !== this.id) return;

      this.focusOnClose = e.target;
      this._open(e.detail.html);
    };

    this.handleClose = (e) => {
      this._close(e.detail.focusOnClose);
    };

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items within an old modal.
      if (!document.body.contains(e.target)) return;

      if (this._isOpen && !this.inner.contains(e.target)) {
        this._close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this._isOpen && e.code.toUpperCase() === "ESCAPE") {
        this._close();
      }
    };

    document.addEventListener("markup-modal:open", this.handleOpen);
    document.addEventListener("markup-modal:close", this.handleClose);
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.handleKeyUp);
    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-close]")) return;

      this._close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener("markup-modal:open", this.handleOpen);
    document.removeEventListener("markup-modal:close", this.handleClose);
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  _open(html) {
    this._setContent(html);
    this.style.display = null;
    window.openFullDimmer(this);

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this._isOpen = true;
      window.lockScroll(this);
      window.trapFocus(this, this.querySelector("[data-close]"));
    });
  }

  _close(focusOnClose = this.focusOnClose) {
    if (!this._isOpen) return;

    const handleTransitionEnd = () => {
      this.removeEventListener("transitionend", handleTransitionEnd);
      this._setContent("");
      this.innerWrapper.scrollTop = 0;
      this.style.display = "none";
      window.removeTrapFocus(focusOnClose);
      window.unlockScroll(this);
      this._isOpen = false;
    };

    this.addEventListener("transitionend", handleTransitionEnd);
    this.removeAttribute("open");
    window.closeFullDimmer(this);
  }

  get isStatic() {
    return this.hasAttribute("static");
  }

  _setContent(html) {
    if (this.isStatic) return;

    this.content.innerHTML = html;
  }
}

if (!customElements.get("markup-modal")) {
  customElements.define("markup-modal", MarkupModal);
}
